import { d, std } from 'typegpu';

export const hash = (px: number, py: number) => {
  'use gpu';
  const dot = px * 127.1 + py * 311.7;
  return std.fract(std.sin(dot) * 43758.5453);
};

export const samplePerturb = (hx: number, hy: number, perturb: number, mode: number) => {
  'use gpu';
  if (mode < 0.5) {
    return (hash(hx, hy) * 2 - 1) * perturb;
  }
  const u1 = std.max(hash(hx, hy), 0.0000000001);
  const u2 = hash(hx + 1000, hy - 999);
  return std.sqrt(-2 * std.log(u1)) * std.cos(6.28318530718 * u2) * perturb;
};
